
import moment from 'moment'
import { mapGetters } from 'vuex'
import { isGPOCustomer } from '~/helpers/user'

const DATE_FORMAT = 'MM/DD/YYYY'
export default {
  name: 'TermsAndConditionsText',
  props: {
    subscriptionPlan: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters('user', ['user', 'practice', 'practiceLocation', 'name']),
    practiceLocationCreatedDate() {
      return this.practiceLocation?.createdAt
        ? moment(this.practiceLocation.createdAt)
        : null
    },
    practiceLocationCreatedDateFormatted() {
      return this.practiceLocationCreatedDate
        ? this.practiceLocationCreatedDate.format(DATE_FORMAT)
        : null
    },
    serviceStartDate() {
      return this.practiceLocationCreatedDate
        ? (this.isGpo ? this.practiceLocationCreatedDate : this.practiceLocationCreatedDate.add(this.trialDays, 'days'))
        : null
    },
    serviceStartDateDay() {
      return this.serviceStartDate ? this.serviceStartDate.format('D') : null
    },
    serviceStartDateAfterYear() {
      return this.serviceStartDate ? this.serviceStartDate.add(1, 'year') : null
    },
    serviceStartDateFormatted() {
      return this.serviceStartDate
        ? this.serviceStartDate.format(DATE_FORMAT)
        : null
    },
    serviceStartDateAfterYearFormatted() {
      return this.serviceStartDateAfterYear
        ? this.serviceStartDateAfterYear.format(DATE_FORMAT)
        : null
    },
    doctorName() {
      return this.user?.name ?? ''
    },
    practiceState() {
      return this.practice?.state ?? ''
    },
    isGpo() {
      return isGPOCustomer(this.$store)
    },
    gpoName() {
      return this.isGpo
        ? this.practiceLocation.buyingGroups.includes('source_club') ? 'Source Club' : 'Fireside Dental Co.'
        : ''
    },
    subscriptionMonthlyPrice() {
      return this.practiceLocation?.renewalAmount ?? (this.isGpo ? 0 : 99) // RelationWithPracticeAndUser does not return renewalAmount
    },
    trialDays() {
      return this.user.practiceLocation.trialPeriod ?? 14
    },
    subscriptionChargeFreq() {
      return this.isGpo
        ? `ZenOne charges and collects the monthly or annual membership fee, as applicable, directly from ${this.gpoName}, LLC. Client guarantees that it will provide any needed hardware, mobile devices, such as iPad, during the initial setup and later upgrade devices at ZenOne’s recommendation to facilitate operation according to ZenOne specifications. In the event that Client fails to follow ZenOne’s recommendations, ZenOne shall not have any responsibility for failure to meet ZenOne specifications.`
        : `ZenOne charges and collects the monthly or annual membership fee, as applicable, after a ${this.trialDays}-day free trial of the system for Client’s use of the Services. Client guarantees that it will provide any needed hardware, mobile devices, such as iPad, during the initial setup and later upgrade devices at ZenOne’s recommendation to facilitate operation according to ZenOne specifications. In the event that Client fails to follow ZenOne’s recommendations, ZenOne shall not have any responsibility for failure to meet ZenOne specifications.`    },
    membershipTermText() {
      return this.isGpo
        ? `${this.gpoName}, LLC will will pay the Membership Fee for the Services provided pursuant to Client’s selected subscription beginning (${this.serviceStartDateFormatted}) and ending on (${this.serviceStartDateAfterYearFormatted}). This agreement will be automatically renewed every month unless canceled in writing a minimum of 30 days prior to the expiration.`
        : `Client will pay the Membership Fee for the Services provided pursuant to Client’s selected subscription beginning after a ${this.trialDays}-day free trial period (${this.serviceStartDateFormatted}) and ending on (${this.serviceStartDateAfterYearFormatted}). This agreement will be automatically renewed every 12 months for an additional 12-month period unless canceled in writing a minimum of 30 days prior to the expiration.`
    },
    practiceLocationName() {
      return this.practiceLocation?.name ?? '______________________'
    },
  },
}
